import { render, staticRenderFns } from "./ShipmentBarCodeSingle.vue?vue&type=template&id=5f35b197&scoped=true"
import script from "./ShipmentBarCodeSingle.vue?vue&type=script&lang=js"
export * from "./ShipmentBarCodeSingle.vue?vue&type=script&lang=js"
import style0 from "./ShipmentBarCodeSingle.vue?vue&type=style&index=0&id=5f35b197&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f35b197",
  null
  
)

export default component.exports